import {
  List,
  Datagrid,
  TextField,
  EditButton,
  FunctionField,
  usePermissions,
} from "react-admin";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Visibility";
import { Typography, Box } from "@mui/material";


const FormList = (props) => {
  const { permissions = [] } = usePermissions();

  return (
    <List title="Feedback Types" {...props}>
            <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Feedback Forms
        </Typography>
      </Box>
      <Datagrid>
        <TextField source="id" />
        <TextField source="title" />

        {(permissions.includes("forms.edit") ||
          permissions.includes("forms.*") ||
          permissions.includes("*")) }

        {(permissions.includes("forms.read") ||
          permissions.includes("forms.*") ||
          permissions.includes("*")) && (
          <FunctionField
            label="Preview"
            render={(record) => (
              <Button
                component={Link}
                to={`/forms/${record.id}/preview`}
                size="small"
                startIcon={<PreviewIcon />}
              >
                Preview
              </Button>
            )}
          />
        )}
      </Datagrid>
    </List>
  );
};

export default FormList;
